import { Field } from 'formik'
import { useCurrentProving } from 'hooks/useCurrentProving'
import { ProvingPermission } from 'model'
import * as React from 'react'

export const AuthorizedField: React.FC<any> = (props) => {
  const [proving] = useCurrentProving()
  const disabled =
    proving &&
    proving.authorization!.permissions!.indexOf(ProvingPermission.Update) === -1

  return <Field {...props} disabled={disabled || props.disabled} />
}
